import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getNamedBusyIndicator } from '../busyIndicator/busyIndicator.selectors'
import { DataTable } from '@/components/DataTable'

const Table = ({
	columns,
	data = [],
	keyField,
	caption,
	selectRow,
	region,
	expandRow,
	outerTable = false,
	innerTable = false,
	stripedTable = true,
	rowEvents,
	isDisplayTable = false,
	rowClasses = 'text-table-data',
	...props
}) => {
	const shouldBusyIndicatorRender = useSelector(getNamedBusyIndicator(region))

	// Map legacy react-bootstrap-table columns to TanStack columns when needed
	const mappedColumns = useMemo(() => {
		if (!columns || Array.isArray(columns) === false) return []
		// If already TanStack ColumnDefs, pass through
		if (columns.length && (columns[0].accessorKey || columns[0].accessorFn)) return columns
		return columns.map((col, idx) => {
			const accessorKey = col.dataField || undefined
			const safeId = accessorKey || (typeof col.text === 'string' ? col.text : `col_${idx}`)
			return {
				id: String(safeId) || `col_${idx}`,
				header: col.text,
				accessorKey,
				cell: col.formatter
					? ({ getValue, row }) => col.formatter(getValue?.(), row.original)
					: ({ getValue }) => getValue?.(),
				enableSorting: !!col.sort,
			}
		})
	}, [columns])

	const emptyMessage = shouldBusyIndicatorRender ? 'No Data Found' : 'No Data Found'

	return (
			<DataTable columns={mappedColumns} data={data} emptyMessage={emptyMessage} />
	)
}

export default Table
